import React, { useEffect, useState } from 'react';
import { ContainerComponent } from '../../../core/components/container.component';
import { getBRTCity, saveBRTCity } from '../../../core/services/localStorage.service';
import { THEME_STATE_KEY } from '../../../core/services/CONSTANTS';
import Zoom from 'react-medium-image-zoom';
import { ColumnComponent } from '../../../core/components/base/column.component';
import { SwipeableDrawer } from '@mui/material';
import LayoutDrawer from '../../../core/components/layoutDrawer.component';
import CloseIcon from '@mui/icons-material/CloseRounded';
import { RowComponent } from '../../../core/components/base/row.component';
import { TABRIZ_CITY, TEHRAN_CITY } from '../../../page/tools/subway/CONSTANTS';
import { Check } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { getLightImageUrl, getNightImageUrl } from '../../../page/tools/brt_map/brt.utils';
import axios from 'axios';
import { Buffer } from 'buffer';
import { NextPage } from 'next';
import useLocalStorageState from '../../../core/utils/useLocalStorage';

const BRT: NextPage = () => {
  const [resultOpen, setResultOpen] = useState(false);
  const [chooseCity, setChooseCity] = useState<string>('');
  const { t } = useTranslation();
  const [image, setImage] = useState('');
  const [isDark, setDark] = useLocalStorageState<boolean>(THEME_STATE_KEY, false);

  useEffect(() => {
    setChooseCity(getBRTCity());
    if (!getBRTCity()) {
      setResultOpen(true);
    }
    getBase64(isDark ? getNightImageUrl(chooseCity) : getLightImageUrl(chooseCity)).then((base64) => {
      setImage(base64);
    });
  }, [chooseCity]);

  function clickCityItem(city: string) {
    saveBRTCity(city);
    setChooseCity(city);
    setResultOpen(false);
  }

  async function getBase64(url: string) {
    return axios
      .get(url, {
        responseType: 'arraybuffer'
      })
      .then((response) => Buffer.from(response.data, 'binary').toString('base64'));
  }

  return (
    <ContainerComponent onSettingClick={() => setResultOpen(true)}>
      <ColumnComponent className="w-full px-5 py-5">
        <Zoom>
          <img
            crossOrigin="anonymous"
            alt={''}
            src={`data:image/svg+xml;base64,${image}`}
            width={'100%'}
            className={'mt-3'}
            style={{ backgroundColor: isDark ? '#000' : '#FFF' }}
            height={'100%'}
          />
        </Zoom>
      </ColumnComponent>
      <SwipeableDrawer
        anchor={'bottom'}
        open={resultOpen}
        PaperProps={{ square: false, elevation: 0, style: { backgroundColor: 'transparent' } }}
        onOpen={() => setResultOpen(true)}
        onClose={() => setResultOpen(!resultOpen)}
      >
        <LayoutDrawer>
          <CloseIcon className="closeIcon" fontSize={'large'} onClick={() => setResultOpen(false)} />
          <div className="text-center w-full text-bold mt-4">{t('chooseCity')}</div>
          <ColumnComponent className="fullWidth totalCenter p-3">
            <RowComponent className={'mt-4 items-center p-2 pointer'} onClick={() => clickCityItem(TEHRAN_CITY)}>
              <div className="grow">{t('cities.tehran')}</div>
              {chooseCity == TEHRAN_CITY ? <Check fontSize={'medium'} className="mTextBlue" /> : null}
            </RowComponent>
            <div className="separatorLine w-full mt-1 mb-1" />
            <RowComponent className={'mt-4 items-center p-2 pointer'} onClick={() => clickCityItem(TABRIZ_CITY)}>
              <div className="grow">{t('cities.tabriz')}</div>
              {chooseCity == TABRIZ_CITY ? <Check fontSize={'medium'} className="mTextBlue" /> : null}
            </RowComponent>
            <div className="separatorLine w-full mt-1 mb-1" />
          </ColumnComponent>
        </LayoutDrawer>
      </SwipeableDrawer>
    </ContainerComponent>
  );
};

export default BRT;
